import { render, staticRenderFns } from "./SchoolLinkSource.vue?vue&type=template&id=c7d3310e&scoped=true"
import script from "./SchoolLinkSource.vue?vue&type=script&lang=js"
export * from "./SchoolLinkSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d3310e",
  null
  
)

export default component.exports